// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=Currency|schemaHash=166bafd76f3e10e20a3e8061e7c9c7d83ad41ea7

import { setDefinedValue } from '@myre/common-primitives';

export function parseCurrencyFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'code', _data.code);
  setDefinedValue(result, 'name', _data.name);
  setDefinedValue(result, 'iso4217', _data.iso4217);
  setDefinedValue(result, 'id', _data.id);

  return result;
}

export function parseCurrencyToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'code', _data.code);
  setDefinedValue(result, 'name', _data.name);
  setDefinedValue(result, 'iso4217', _data.iso4217);
  setDefinedValue(result, 'id', _data.id);

  return result;
}
